import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Appliance } from '@common/util-models';
import { BasketFacade } from '@sky/data-access-basket';
import { MOBILE_APPLIANCE_CODE } from '@sky/util-foundation';

import { CatalogFacade } from '../+state/catalog.facade';

export const VIRTUAL_APPLIANCE = {
  code: 'VIRTUAL',
  description: 'Mobile phone cover',
} as Appliance;

@Injectable()
export class MobileJourneyResolver implements Resolve<unknown> {
  constructor(
    private basketFacade: BasketFacade,
    private catalogFacade: CatalogFacade
  ) {}

  resolve() {
    this.basketFacade.removeAllDevices();
    this.basketFacade.loadQuotes(VIRTUAL_APPLIANCE.code);
    this.catalogFacade.setBaseAppliance(VIRTUAL_APPLIANCE);
    this.catalogFacade.loadBrands(MOBILE_APPLIANCE_CODE);
  }
}
